<template>
  {{! template-lint-disable require-iframe-title }}
  <iframe
    class="product-portal"
    frameborder="0"
    src="https://portal.productboard.com/brjwhukoh3zt8ebrqjlainfd"
  ></iframe>
</template>
